import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, ArrowRight } from "lucide-react";
import { SITE } from "@/lib/site";

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer className="bg-white border-t border-[#1A1A1A]/10" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-20 lg:py-24">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16">
          <div className="lg:col-span-5">
            <Link to="/" className="inline-block" data-testid="footer-logo">
              <div className="font-heading text-2xl text-[#1A1A1A] tracking-tight" style={{ fontWeight: 900, letterSpacing: "-0.01em" }}>
                RVA<span className="text-[#F97316] mx-1">·</span>SIGNS
              </div>
              <div className="text-[10px] tracking-[0.18em] uppercase text-[#5F6B73] mt-1.5 font-semibold">A Richmond Signage Resource</div>
            </Link>
            <h3 className="font-heading text-2xl sm:text-3xl tracking-tight text-[#1A1A1A] leading-tight mt-8 max-w-md" style={{ fontWeight: 800 }}>
              Need a sign?<br />Let&rsquo;s talk.
            </h3>
            <p className="mt-5 text-[#2B2F33]/75 text-base leading-relaxed max-w-md">
              Got a sign project? Let&rsquo;s talk.
            </p>
            <Link
              to="/contact"
              data-testid="footer-cta"
              className="inline-flex items-center gap-2 mt-8 text-sm font-bold uppercase tracking-wider text-[#F97316] hover:gap-3 transition-all"
            >
              Talk to Todd <ArrowRight className="w-4 h-4" />
            </Link>
          </div>

          <div className="lg:col-span-3">
            <div className="text-[10px] tracking-[0.22em] uppercase text-[#5F6B73] font-bold mb-5">Site</div>
            <ul className="space-y-3 text-sm">
              <li><Link to="/" className="text-[#1A1A1A]/80 hover:text-[#F97316] transition-colors">Home</Link></li>
              <li><Link to="/resources" className="text-[#1A1A1A]/80 hover:text-[#F97316] transition-colors">Answers</Link></li>
              <li><Link to="/about" className="text-[#1A1A1A]/80 hover:text-[#F97316] transition-colors">About Todd</Link></li>
              <li><Link to="/projects" className="text-[#1A1A1A]/80 hover:text-[#F97316] transition-colors">Projects</Link></li>
              <li><Link to="/contact" className="text-[#1A1A1A]/80 hover:text-[#F97316] transition-colors">Contact</Link></li>
            </ul>
          </div>

          <div className="lg:col-span-4">
            <div className="text-[10px] tracking-[0.22em] uppercase text-[#5F6B73] font-bold mb-5">Talk to Todd</div>
            <ul className="space-y-4 text-sm">
              <li className="flex items-start gap-3">
                <Phone className="w-4 h-4 text-[#F97316] mt-1 shrink-0" />
                <a href={SITE.phoneHref} className="text-[#1A1A1A] text-lg font-bold hover:text-[#F97316] transition-colors" data-testid="footer-phone">{SITE.phone}</a>
              </li>
              <li className="flex items-start gap-3">
                <Mail className="w-4 h-4 text-[#F97316] mt-1 shrink-0" />
                <a href={SITE.emailHref} className="text-[#2B2F33]/85 hover:text-[#F97316] break-all transition-colors" data-testid="footer-email">{SITE.email}</a>
              </li>
              <li className="flex items-start gap-3">
                <MapPin className="w-4 h-4 text-[#F97316] mt-1 shrink-0" />
                <span className="text-[#2B2F33]/85">{SITE.address}</span>
              </li>
            </ul>
            <div className="mt-6 text-xs text-[#5F6B73] leading-relaxed">
              Todd Friedman works with the team at Superior Signs in Richmond, Virginia.
            </div>
          </div>
        </div>

        <div className="border-t border-[#1A1A1A]/10 mt-16 pt-6 flex flex-col sm:flex-row justify-between gap-3 text-xs text-[#5F6B73]">
          <div>&copy; {year} RVA Signs. Richmond, Virginia.</div>
          <div>Got a sign project? Let&rsquo;s talk.</div>
        </div>
      </div>
    </footer>
  );
}
